import { morph } from '@theme/morph';

class NooshStickyBar extends HTMLElement {
  connectedCallback() {
    this.triggerSelector = this.dataset.trigger;
    this.hideAtSelector = this.dataset.hideAt;
    this.triggerEl = this.findSectionElement(this.triggerSelector);
    this.hideAtEl = this.findSectionElement(this.hideAtSelector) || document.querySelector('footer');

    this.scrollLink = this.querySelector('[data-scroll-to]');
    if (this.scrollLink) {
      this.scrollLink.addEventListener('click', (event) => this.handleClick(event));
    }

    if (!this.triggerEl) return;

    this.pastTrigger = false;
    this.pastHideAt = false;

    this.triggerObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        this.pastTrigger = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
        this.updateVisibility();
      },
      { threshold: 0 }
    );
    this.triggerObserver.observe(this.triggerEl);

    if (this.hideAtEl) {
      this.hideAtObserver = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          this.pastHideAt = entry.isIntersecting;
          this.updateVisibility();
        },
        { threshold: 0 }
      );
      this.hideAtObserver.observe(this.hideAtEl);
    }
  }

  findSectionElement(selector) {
    if (!selector) return null;
    const exact = document.querySelector(selector);
    if (exact) return exact;

    const sectionKey = selector.replace(/^#/, '').replace(/^shopify-section-/, '');
    return document.querySelector(`[id$="__${sectionKey}"], [id$="-${sectionKey}"]`);
  }

  updateVisibility() {
    const shouldShow = this.pastTrigger && !this.pastHideAt;
    if (shouldShow) {
      this.setAttribute('data-visible', '');
    } else {
      this.removeAttribute('data-visible');
    }
  }

  async handleClick(event) {
    const quickAddUrl = this.scrollLink.dataset.quickAddUrl;
    if (quickAddUrl && (await this.openQuickAdd(event, quickAddUrl))) return;

    const targetSelector = this.scrollLink.dataset.scrollTo;
    const target = targetSelector ? document.querySelector(targetSelector) : null;
    if (target) {
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  async openQuickAdd(event, url) {
    const dialog = document.getElementById('quick-add-dialog');
    const modalContent = document.getElementById('quick-add-modal-content');
    if (!dialog || !modalContent || typeof dialog.showDialog !== 'function') return false;

    event.preventDefault();

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Request failed: ${response.status}`);
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const productGrid = parsed.querySelector('[data-product-grid-content]');
      if (!productGrid) throw new Error('Could not find product content in response');

      morph(modalContent, productGrid);
      dialog.showDialog();
      return true;
    } catch (error) {
      console.error('Sticky ATC quick add failed, falling back to scroll:', error);
      return false;
    }
  }
}

if (!customElements.get('noosh-sticky-bar')) {
  customElements.define('noosh-sticky-bar', NooshStickyBar);
}
